exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@keyframes loading{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.asda-spinner{display:inline-block;border-radius:50%;border-width:2px;border-style:solid;animation:loading .7s infinite linear}.asda-spinner--center{display:block;margin:10px auto}.asda-spinner--primary{border-color:#68a51c;border-top-color:#fff}.asda-spinner--primary-light{border-color:#b4d28e;border-top-color:#fff}.asda-spinner--secondary{border-color:#0073b1;border-top-color:#fff}.asda-spinner--secondary-light{border-color:#7fb9d8;border-top-color:#fff}.asda-spinner--clear,.asda-spinner--clear-light{border-color:#ccc;border-top-color:#fff}.asda-spinner--small{width:20px;height:20px}.asda-spinner--medium{width:40px;height:40px}.asda-spinner--large{width:60px;height:60px}.asda-spinner__overlay{background:hsla(0,0%,100%,.5);position:absolute;top:0;left:0;right:0;bottom:0;z-index:1;display:flex;align-items:center;justify-content:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/dist/cjs.js??ref--1-3!./common/components/spinner/_style.scss
// module id = 844
// module chunks = 0